import { useState } from "react";
import { Linkedin, Copy, Check, MessageCircle, Download } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "../../i18n/LanguageContext";

const API = process.env.REACT_APP_BACKEND_URL;
const SITE = "https://margtor.africa";
const btnCls = "chamfer-sm inline-flex items-center gap-2 px-3.5 py-2 font-mono-tech text-[10px] font-semibold uppercase tracking-[0.15em] transition-all duration-200 hover:-translate-y-0.5";

export const TcoShare = ({ km, fuel, fleet, nums }) => {
  const { lang, t } = useLang();
  const s = t.tco.share;
  const [copied, setCopied] = useState(false);
  const qs = `km=${km}&fuel=${fuel}&fleet=${fleet}&lang=${lang}`;
  const shareUrl = `${SITE}/api/share/tco?${qs}`;
  const imgUrl = `${typeof window !== "undefined" && window.location.hostname.endsWith("margtor.africa") ? SITE : API}/api/share/tco.png?${qs}`;
  const fill = (str) => str.replace(/\{(\w+)\}/g, (_, k) => ({ km, fuel, fleet, ...nums })[k]);
  const post = `${fill(s.post)}\n\n${shareUrl}\n\n${s.hashtags}`;

  const copyPost = async () => {
    try {
      await navigator.clipboard.writeText(post);
      setCopied(true);
      toast.success(s.copiedTitle, { description: s.copiedBody });
      setTimeout(() => setCopied(false), 2500);
    } catch {
      toast.error(s.copyFailed);
    }
  };

  return (
    <div data-testid="tco-share" className="mt-6 border-t border-[#f8f7f4]/15 pt-6 flex flex-col md:flex-row gap-5 md:items-center">
      <a href={shareUrl} target="_blank" rel="noopener noreferrer" data-testid="tco-share-preview" className="chamfer-sm relative block w-full md:w-60 shrink-0 overflow-hidden border border-[#f8f7f4]/15 transition-transform duration-300 hover:scale-[1.02]">
        <img src={imgUrl} alt={s.alt} width={1200} height={630} loading="lazy" className="block w-full h-auto" />
        <span className="absolute right-2 top-2 bg-ink/80 px-2 py-0.5 font-mono-tech text-[9px] uppercase tracking-[0.2em] text-[#f8f7f4]/80">{s.previewTag}</span>
      </a>
      <div className="min-w-0 flex-1">
        <p className="font-mono-tech text-[0.65rem] tracking-[0.28em] uppercase text-[#e63946]" data-testid="tco-share-eyebrow">{s.eyebrow}</p>
        <p className="mt-2 text-xs leading-relaxed text-[#f8f7f4]/60">{s.desc}</p>
        <div className="mt-3.5 flex flex-wrap gap-2">
          <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`} target="_blank" rel="noopener noreferrer" data-testid="tco-share-linkedin" className={`${btnCls} bg-[#0a66c2] text-white hover:bg-[#0958a8]`}>
            <Linkedin className="h-3.5 w-3.5" /> {s.linkedin}
          </a>
          <a href={`https://wa.me/?text=${encodeURIComponent(post)}`} target="_blank" rel="noopener noreferrer" data-testid="tco-share-whatsapp" className={`${btnCls} border border-[#f8f7f4]/25 text-[#f8f7f4]/85 hover:border-[#25d366]`}>
            <MessageCircle className="h-3.5 w-3.5" /> WhatsApp
          </a>
          <button type="button" onClick={copyPost} data-testid="tco-share-copy" className={`${btnCls} border border-[#f8f7f4]/25 text-[#f8f7f4]/85 hover:border-[#e63946]`}>
            {copied ? <Check className="h-3.5 w-3.5 text-[#3ddc84]" /> : <Copy className="h-3.5 w-3.5" />} {copied ? s.copied : s.copy}
          </button>
          <a href={imgUrl} download={`margtor-tco-${fleet}-bikes.png`} data-testid="tco-share-download" className={`${btnCls} border border-[#f8f7f4]/25 text-[#f8f7f4]/85 hover:border-[#e63946]`}>
            <Download className="h-3.5 w-3.5" /> {s.download}
          </a>
        </div>
      </div>
    </div>
  );
};
